/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import WsBundleVariantPicker from './WsBundleVariantPicker';
import WsVariantPickerControls from './WsVariantPickerControls';

const WsVariantPickerBlock = ({
  ecomStoreCartProductInputAnswers,
  isBundleProduct,
  ecomStoreProduct,
  onVariantChange,
  onInputChange,
  onBundleProductVariantSelect,
  selectedVariants,
  selectedVariantsInfo,
  selectedProductVariantsState,
  storeProductOptions,
  submitting,
  mediaQueries,
  config,
  baseStoreUrl,
  onNavigate,
  editModeEnabled,
  adjustments,
  isCartEdit
}) =>
  isBundleProduct ? (
    <WsBundleVariantPicker
      adjustments={adjustments}
      baseStoreUrl={baseStoreUrl}
      config={config}
      ecomStoreCartProductInputAnswers={ecomStoreCartProductInputAnswers}
      ecomStoreProduct={ecomStoreProduct}
      editModeEnabled={editModeEnabled}
      isBundleProduct={isBundleProduct}
      isCartEdit={isCartEdit}
      mediaQueries={mediaQueries}
      onBundleProductVariantSelect={onBundleProductVariantSelect}
      onInputChange={onInputChange}
      onNavigate={onNavigate}
      onVariantChange={onVariantChange}
      selectedProductVariantsState={selectedProductVariantsState}
      selectedVariants={selectedVariants}
      selectedVariantsInfo={selectedVariantsInfo}
      storeProductOptions={storeProductOptions}
      submitting={submitting}
    />
  ) : (
    <WsVariantPickerControls
      baseStoreUrl={baseStoreUrl}
      config={config}
      ecomStoreCartProductInputAnswers={
        selectedProductVariantsState[0]?.ecomStoreCartProductInputAnswers || []
      }
      ecomStoreProduct={ecomStoreProduct}
      editModeEnabled={editModeEnabled}
      isBundleProduct={isBundleProduct}
      isCartEdit={isCartEdit}
      mediaQueries={mediaQueries}
      onInputChange={onInputChange}
      onNavigate={onNavigate}
      onVariantChange={onVariantChange}
      selectedOptions={selectedProductVariantsState[0]?.selectedOptions || []}
      selectedVariant={selectedVariants[0]}
      submitting={submitting}
      variantOptions={storeProductOptions[0]?.variantOptions || []}
    />
  );

WsVariantPickerBlock.propTypes = {
  adjustments: PropTypes.object,
  baseStoreUrl: PropTypes.string,
  config: PropTypes.object,
  ecomStoreCartProductInputAnswers: PropTypes.array,
  ecomStoreProduct: PropTypes.object,
  editModeEnabled: PropTypes.bool,
  isBundleProduct: PropTypes.bool,
  isCartEdit: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onBundleProductVariantSelect: PropTypes.func,
  onInputChange: PropTypes.func,
  onNavigate: PropTypes.func,
  onVariantChange: PropTypes.func,
  selectedProductVariantsState: PropTypes.array,
  selectedVariants: PropTypes.array,
  selectedVariantsInfo: PropTypes.array,
  storeProductOptions: PropTypes.array,
  submitting: PropTypes.bool,
  variantOptions: PropTypes.array
};

export default WsVariantPickerBlock;
